var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApp3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3995_102213)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 14,
    fill: "url(#paint0_linear_3995_102213)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6972 22.1972C20.5843 20.3102 23.1438 19.25 25.8125 19.25C28.4812 19.25 31.0407 20.3102 32.9278 22.1972C34.7115 23.9809 35.7564 26.3654 35.8655 28.875L39.5029 28.875C40.5387 28.875 41.0566 28.875 41.4653 29.0701C41.8252 29.2419 42.1255 29.5174 42.3277 29.8612C42.5573 30.2516 42.6019 30.7675 42.6911 31.7995L44.8037 56.243L40.4461 56.632L38.4365 33.25H36.3125V37.625L32.375 41.125V33.25L13.2617 33.25L11.6569 56.5934L7.29297 56.2817L8.98208 31.8543C9.05466 30.8046 9.09095 30.2798 9.3185 29.882C9.51884 29.5317 9.82044 29.2503 10.1837 29.0746C10.5963 28.875 11.1223 28.875 12.1744 28.875H12.1745L15.7595 28.875C15.8686 26.3654 16.9135 23.9809 18.6972 22.1972ZM30.4529 24.6721C31.5801 25.7993 32.2549 27.2943 32.3604 28.875L19.2646 28.875C19.3701 27.2943 20.0449 25.7993 21.1721 24.6721C22.4028 23.4414 24.072 22.75 25.8125 22.75C27.553 22.75 29.2222 23.4414 30.4529 24.6721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8752 12.5875C42.9071 12.5875 42.9389 12.5882 42.9706 12.589C43.0061 12.59 43.0414 12.5915 43.0767 12.5933C43.8437 12.6309 44.5548 12.8836 45.1513 13.2921L46.1725 12.5397C45.2713 11.8112 44.1244 11.375 42.8752 11.375C41.5201 11.375 40.2845 11.8885 39.3529 12.7318C38.2917 13.6924 37.625 15.0808 37.625 16.6248C37.625 18.0744 38.2125 19.3872 39.1627 20.3375C40.1128 21.2877 41.4257 21.875 42.8753 21.875C44.23 21.8749 45.4652 21.3616 46.3967 20.5186L46.3976 20.5197L46.5097 20.4152C47.5051 19.4598 48.125 18.115 48.125 16.6257C48.125 16.3044 48.0961 15.9902 48.0409 15.6846L46.9109 16.5177L46.912 16.5715L46.9125 16.6253C46.9125 17.7383 46.4599 18.7477 45.7293 19.4789L45.7287 19.4783C44.9974 20.2089 43.9881 20.662 42.8751 20.662C42.8074 20.662 42.7402 20.6603 42.6735 20.657C41.5692 20.6023 40.5801 20.1018 39.8831 19.3321L39.8826 19.3326C39.2339 18.6157 38.8379 17.6658 38.8379 16.625C38.8383 15.4393 39.3515 14.3717 40.1678 13.6325C40.8847 12.9834 41.8345 12.5875 42.8752 12.5875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6866 14.447C47.5185 14.0711 47.3075 13.7164 47.0579 13.3902L42.9061 16.4879L40.9088 15.2226V16.7489L42.9061 18.0179L47.6866 14.447Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 13.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3995_102213",
    x1: 52.5,
    y1: -3.06251,
    x2: -13.0247,
    y2: 27.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131556,
    stopColor: "#672EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#6956C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#567CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802171,
    stopColor: "#25A78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FA994"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3995_102213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp3);
export default __webpack_public_path__ + "static/media/app-3.fa300aaccbbb4265dd469a94654c71fb.svg";
export { ForwardRef as ReactComponent };